import React from "react";
import "./AboutUs.css";

const AboutUsHead = () => {
  return (
    <div className="aboutUsHeadContainer">
      <h2>
        Your Trustworthy Partner in <span>Certificate Attestation</span> and{" "}
        <span>Apostille!</span>
      </h2>
    </div>
  );
};

export default AboutUsHead;
